import { MarkdownEditorField } from '@/components/markdown/markdown-editor-field'
import {
  Card,
  CardContent,
} from '@/components/ui/card'
import { useAuth } from '@/hooks/use-auth'
import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { CardHeaderWithBadge } from './-components/card-header-with-badge'
import { useCompanyFieldForm } from './-components/use-company-field-form'

const parentRoute = getRouteApi('/_authed/_user/organization')

export const Route = createFileRoute(
  '/_authed/_user/organization/outreach',
)({
  component: OutreachSection,
  beforeLoad: () => ({
    getTitle: () => 'Outreach',
    getDescription: () => 'Define organization-wide guidelines for AI-generated emails',
  }),
})

function OutreachSection() {
  const { canEditOutreach: canEdit } = useAuth()
  const { initialData, hasCompanyInfo } = parentRoute.useLoaderData()

  const { form, NavBlocker } = useCompanyFieldForm({
    fieldName: 'emailSystemPrompt',
    initialData,
  })

  return (
    <>
      <Card className={canEdit ? '' : 'opacity-75'}>
        <CardHeaderWithBadge
          title="Email Communication Guidelines"
          description="Define organization-wide guidelines for AI-generated emails. These instructions will be applied to all emails generated by team members to ensure consistent tone, style, and messaging across your organization."
          form={form}
          fieldName="emailSystemPrompt"
          hasCompanyInfo={hasCompanyInfo}
        />
        <CardContent>
          <MarkdownEditorField
            form={form}
            name="emailSystemPrompt"
            displayModeByDefault
            placeholder="e.g., Always use a professional but warm tone. Mention our 24/7 customer support. Keep emails under 150 words..."
            disabled={!canEdit}
            showSaveButton={canEdit}
            onSave={() => form.handleSubmit()}
          />
        </CardContent>
      </Card>
      <NavBlocker />
    </>
  )
}
